import GuestlistShifts from '../../../store/guestlists/shifts';

angular
    .module('festzelt-os.guestlists')
    .factory('GuestlistShifts', [
        '$injector',
        'GuestlistShift',
        ($injector, GuestlistShift) => new GuestlistShifts(GuestlistShift, {
            injector: $injector
        })
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/store/shifts.js